import React, { useState, useEffect } from "react";
import { Badge, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { API } from "../../config/api.js";
import LoaderHome from "../Loader/LoaderHome.js";
import Swal from "sweetalert2";
import swal from "sweetalert";
import WellcomeCard from "../Admin/Components/Wellcome.js";
import { useMediaQuery } from "react-responsive";
import HeaderOdontogramProtesaMaterial from "./Components/HeaderOdontogramProtesaMaterial.js";
import ModalAddMedis from "./ModalAdmin/ModalAdd.js";
import ModalUpdateMedis from "./ModalAdmin/ModalUpdate.js"

import TableOdontogramProtesaMaterial from "./Components/TableOdontogram.js";


export default function Login() {
    document.title = "SDC Apps";
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);

    const [getData, setGetData] = useState([]);
    const [getDataProfileDetail, setGetDataProfileDetail] = useState([]);

    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 980px)' })
    const [query, setQuery] = useState("");
    const [limit, setLimit] = useState(10);
    const [modalAdd, setModalAdd] = useState(false);
    const [modalUpdate, setModalUpdate] = useState(false);

    const [page, setPage] = useState(0);
    const [pages, setPages] = useState();
    const [ascending, setAscending] = useState(0);
    const [rows, setRows] = useState(1);
    const [keyword, setKeyword] = useState("");
    const [msg, setMsg] = useState("");
    const [id, setId] = useState();
    const [name, setName] = useState();
    const [displayName, setDisplayName] = useState();
    const [codeDisplayName, setCodeDisplayName] = useState();
    const [sctId, setSctId] = useState();
    const [description, setDescription] = useState();

    const token = localStorage.getItem("token");


    let fetchParams = {
        headers: { "Authorization": `${token}`, "Content-Type": "application/json" }
    };

    const GetResponseData = async () => {
        try {
            // e.preventDefault();
            setLoading(true)
            const response = await API.get(`emr-service/dental-protesa-materials?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}`, fetchParams)
            // Checking process
            if (response?.status === 200) {
                setGetData(response.data.data)
                setPage(response.data.pagination.current_page);
                setPages(response.data.pagination.total_pages);
                setRows(response.data.pagination.total);
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            if (error.response.status === 401) {
                navigate('/dashboard')
                swal({
                    title: 'Failed',
                    text: `Akses dibatasi Tidak Dapat Mengakses Halaman Ini`,
                    icon: 'error',
                    timer: 3000,
                    buttons: false
                });
            } else {
                swal({
                    title: 'Failed',
                    text: `${error.response.data.message}`,
                    icon: 'error',
                    timer: 3000,
                    buttons: false
                });
            }
        }
    }


    useEffect(() => {
        GetResponseData();
    }, [keyword]);



    const viewModalAdd = () => {
        setModalAdd(true)
    }


    const buttonRefresh = () => {
        window.location.reload();
    };

    const searchData = (e) => {
        e.preventDefault();
        setPage(0);
        setMsg("");
        setKeyword(query);
    };

    const changePage = ({ selected }) => {
        setPage(selected + 1);
        if (selected === 10) {
            setMsg(
                ""
            );
        } else {
            setMsg("");
        }
    };


    const deleteById = async (id) => {
        Swal.fire({
            title: 'Apakah Kamu Yakin?',
            text: `Menghapus data ini`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, Hapus'
        }).then(async (result) => {
            if (result.isConfirmed) {
                const response = await API.delete(`emr-service/dental-protesa-materials/${id}`, fetchParams);
                if (response.data.error === false) {
                    GetResponseData()
                    swal({
                        title: 'Success',
                        text: "Your data has been successfully deleted",
                        icon: 'success',
                        timer: 3000,
                        buttons: false
                    });
                }
            }
        })
    };

    const viewModalUpdate = (id, name, displayName, codeDisplayName, sctId, description) => {
        setModalUpdate(true)
        setId(id)
        setName(name)
        setDisplayName(displayName)
        setCodeDisplayName(codeDisplayName)
        setSctId(sctId)
        setDescription(description)
    }

    return (
        <>
            <Row>
                <WellcomeCard
                    getDataProfileNull={getDataProfileDetail === null}
                    getDataProfileFirstName={getDataProfileDetail?.firstname}
                    getDataProfileLastName={getDataProfileDetail?.lastname}
                />
            </Row>
            <div style={{ backgroundColor: "white", marginTop: "15px", marginLeft: "10px", marginRight: "10px", boxShadow: "2px 2px 10px #BFBFBF" }}>
                {modalAdd && <ModalAddMedis GetResponseData={GetResponseData} show={modalAdd} onHide={() => setModalAdd(false)} />}
                {modalUpdate && <ModalUpdateMedis GetResponseData={GetResponseData} name={name} displayName={displayName} codeDisplayName={codeDisplayName} sctId={sctId} description={description} id={id} show={modalUpdate} onHide={() => setModalUpdate(false)} />}


                {loading && <LoaderHome />}
                <HeaderOdontogramProtesaMaterial
                    isTabletOrMobile={isTabletOrMobile}
                    query={query}
                    setQuery={setQuery}
                    limit={limit}
                    setLimit={setLimit}
                    viewModalAdd={viewModalAdd}
                    searchData={searchData}
                    buttonRefresh={buttonRefresh}
                    showCustomButtonBack={true}
                />

                <Col xl='12' sm='12'>
                    <div>
                        <TableOdontogramProtesaMaterial
                            getData={getData}
                            rows={rows}
                            page={page}
                            pages={pages}
                            changePage={changePage}
                            msg={msg}
                            id={id}
                            name={name}
                            viewModalUpdate={viewModalUpdate}
                            deleteById={deleteById}
                            isTabletOrMobile={isTabletOrMobile}
                        />
                    </div>
                </Col>
            </div>
        </>
    );
}
